<script setup lang="ts">
    import { Bank } from '@/types';
    import { router } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import ConnectEconomic from './ConnectEconomic.vue';
    import ContinueButton from '@/components/ContinueButton.vue';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Permission from '@/enums/Permission';

    interface Props {
        bank: Bank;
    }

    const props = defineProps<Props>();

    const { hasAnyPermission } = usePermissions();

    function handleTransactions() {
        router.visit(route('v2.transactions.index', { account_id: props.bank.id }));
    }
</script>

<template>
    <DataTableActions :data="bank">
        <ConnectEconomic
            v-if="
                hasAnyPermission([
                    Permission.BANK_CREATE,
                    Permission.BANK_UPDATE,
                    Permission.BANK_DELETE,
                ])
            "
            :bank="bank"
        />
        <ContinueButton @click="handleTransactions">
            {{ $t('viia.transactions.page_header') }}
        </ContinueButton>
    </DataTableActions>
</template>
